/**
 * Care Background Agent · frontend/src/components/CodeServerFrame.tsx
 * Live VS Code iframe — real DOM iframe of code-server.
 */

import type { Session } from "../hooks/useSession";

interface Props {
  session: Session | null;
}

export default function CodeServerFrame({ session }: Props) {
  const url = session?.code_server_url;

  if (!url) {
    return (
      <div className="flex flex-col h-full items-center justify-center bg-[#0f1117] text-[#8b8fa8]">
        {session?.status === "booting" || session?.status === "pending" ? (
          <div className="text-center">
            <div className="w-8 h-8 border-2 border-[#5b4dff] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
            <p className="text-sm">Care is booting VS Code…</p>
            <p className="text-xs mt-1 text-[#4a4e65]">Usually ready in ~30s</p>
          </div>
        ) : (
          <div className="text-center">
            <div className="text-3xl mb-3">⌨️</div>
            <p className="text-sm">VS Code not available</p>
            <p className="text-xs mt-1 text-[#4a4e65]">Status: {session?.status ?? "unknown"}</p>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="relative h-full flex flex-col">
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="absolute top-2 right-2 z-10 flex items-center gap-1.5 px-2.5 py-1 bg-[#181c2a]/90 backdrop-blur border border-[#2a2e45] rounded-lg text-xs text-[#8b8fa8] hover:text-white hover:border-[#5b4dff] transition-all"
      >
        ↗ Full screen
      </a>

      <iframe
        src={url}
        title="Care's VS Code"
        className="flex-1 w-full border-0 bg-[#1e1e1e]"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-modals allow-clipboard-read allow-clipboard-write"
        allow="clipboard-read; clipboard-write"
      />
    </div>
  );
}
